import React from 'react';

const HeroStats = ({ type, onStart }) => {
    // Static "Featured" logic suitable for public viewing
    const featuredTopic =
        type === 'pdm' ? 'Product Strategy (Vision)' :
            type === 'tpm' ? 'Global Program Orchestration' :
                type === 'swe' ? 'Big O Notation' :
                    'High-Performing Squads';

    return (
        <div className="hero-stats-container">
            {/* Card 1: Featured Topic / Quick Start */}
            <div className="hero-stat-card action-card">
                <div className="stat-content">
                    <div className="stat-label">Featured Module</div>
                    <div className="stat-value">{featuredTopic}</div>
                    <div className="stat-subtext">Deep Dive available</div>
                </div>
                <button className="hero-start-btn" onClick={() => onStart(featuredTopic)}>Start Review →</button>
            </div>

            {/* Card 2: Quick Guide (Static) */}
            <div className="hero-stat-card guide-card">
                <div className="stat-icon-bg guide">
                    <span role="img" aria-label="compass">🧭</span>
                </div>
                <div className="stat-content">
                    <div className="stat-value-sm">Interactive Mode</div>
                    <div className="stat-label" style={{ textTransform: 'none', color: '#cbd5e1' }}>Select a topic below to start an AI roleplay simulation.</div>
                </div>
            </div>
        </div>
    );
};

export default HeroStats;
